export const defaultErrorMessage = '[FIT] COULD_NOT_FETCH_DATA'
